import type { HttpClient } from '@/lib/http/HttpClient';
import type {
  DeleteToolAliasResponse,
  ToolAlias,
  ToolAliasesResponse,
  ToolAliasSettingsResponse,
  ToolAliasWriteResponse,
} from './ToolAliasApiClient.types';

export class ToolAliasApiClient {
  private readonly http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  async aliasReadAll(companyName?: string, options?: RequestInit) {
    return this.http.post<ToolAliasesResponse>(
      '/api/tracabilite/tool-alias/readAll',
      companyName ? { companyName } : {},
      options,
    );
  }

  async aliasWrite(toolAlias: ToolAlias, options?: RequestInit) {
    return this.http.post<ToolAliasWriteResponse>(
      '/api/tracabilite/tool-alias/write',
      { toolAlias },
      options,
    );
  }

  async aliasDelete(reference: string, companyName?: string, options?: RequestInit) {
    return this.http.post<DeleteToolAliasResponse>(
      '/api/tracabilite/tool-alias/delete',
      companyName ? { reference, companyName } : { reference },
      options,
    );
  }

  async aliasSettingsRead(companyName?: string, options?: RequestInit) {
    return this.http.post<ToolAliasSettingsResponse>(
      '/api/tracabilite/tool-alias/settings/read',
      companyName ? { companyName } : {},
      options,
    );
  }

  async aliasSettingsWrite(displayMode: string, companyName?: string, options?: RequestInit) {
    return this.http.post<ToolAliasSettingsResponse>(
      '/api/tracabilite/tool-alias/settings/write',
      companyName ? { displayMode, companyName } : { displayMode },
      options,
    );
  }
}
